import { Outlet, useLocation } from "react-router";
import { useEffect, useRef } from "react";
import { AppScrollProvider } from "@/hooks/context/app-scroll-context";

const With = ({ children }: { children: React.ReactNode }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    document.documentElement.classList.add("app-shell-locked");
    document.body.classList.add("app-shell-locked");

    return () => {
      document.documentElement.classList.remove("app-shell-locked");
      document.body.classList.remove("app-shell-locked");
    };
  }, []);

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      const root = scrollContainerRef.current;
      if (!root) return;

      root.scrollTop = 0;
      root.querySelectorAll<HTMLElement>("*").forEach((element) => {
        if (element.scrollTop !== 0) element.scrollTop = 0;
      });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname]);

  return (
    <AppScrollProvider value={scrollContainerRef}>
      <div className="relative flex h-dvh w-full flex-col overflow-hidden overscroll-none">
        <header className="fixed inset-x-0 top-0 z-40 flex md:static md:flex-none">{children}</header>
        <div
          ref={scrollContainerRef}
          data-app-scroll
          className="app-shell-scroll absolute inset-x-0 bottom-0 flex min-h-0 w-full overflow-y-auto overflow-x-hidden overscroll-y-none md:static md:flex-1"
        >
          <Outlet />
        </div>
      </div>
    </AppScrollProvider>
  );
};

export default With;
